import { render, staticRenderFns } from "./AddParticularsModal.vue?vue&type=template&id=7d1be08c&scoped=true"
import script from "./AddParticularsModal.vue?vue&type=script&lang=js"
export * from "./AddParticularsModal.vue?vue&type=script&lang=js"
import style0 from "./AddParticularsModal.vue?vue&type=style&index=0&id=7d1be08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1be08c",
  null
  
)

export default component.exports